module.exports = {
  publicPath: process.env.NODE_ENV === 'production' ? '/nachinaizer/' : '/',
  pluginOptions: {
    'style-resources-loader': {
      preProcessor: 'sass',
      patterns: [
        './src/assets/styles/mixins.sass',
        './src/assets/styles/variables.sass'
      ]
    }
  },
  chainWebpack: config => {
    config.module
      .rule('fonts')
      .use('url-loader')
      .loader('url-loader')
      .tap(options => {
        options.fallback.options.name = 'assets/fonts/[name].[ext]'
        return options
      })
  },
  devServer: {
    disableHostCheck: true
  }
}
